const Footer = () => {
  return (
    <footer className="mt-32 mb-16 md:mb-0 my bg-gray-900 text-white w-full ">
      <p className="md:text-xl text-center md:py-10 py-2 ">
        Designed and developed with ❤️ By{" "}
        <a
          className="font-bold"
          href="https://github.com/MohitSinghChauhan"
          target="_blank"
        >
          Mohit Singh Chauhan
        </a>
      </p>
    </footer>
  );
};

export default Footer;
